import { render, staticRenderFns } from "./ProbablyGraduatedStudents.vue?vue&type=template&id=0f2706da&scoped=true&"
import script from "./ProbablyGraduatedStudents.vue?vue&type=script&lang=js&"
export * from "./ProbablyGraduatedStudents.vue?vue&type=script&lang=js&"
import style0 from "./ProbablyGraduatedStudents.vue?vue&type=style&index=0&id=0f2706da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2706da",
  null
  
)

export default component.exports